module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor_magicbook_de-8f75fa38f9ee1de6e3df494453d955c1.png";